import { SelectItem } from 'primeng/api';
import { PendingAreaDisplayStatus, PendingAreaInfoStatus } from '../enums';

export class PendingAreaInfoStatusLookup {

    static getLookup(): SelectItem[] {
        return [
            { label: 'New', value: PendingAreaInfoStatus.New },
            { label: 'Approved', value: PendingAreaInfoStatus.Approved },
            { label: 'Canceled', value: PendingAreaInfoStatus.Canceled }];
    }

    static getAll(): SelectItem[] {
        return [
            { label: 'All', value: null },
            { label: 'Unbilled', value: PendingAreaDisplayStatus.Unbilled },
            { label: 'Billed', value: PendingAreaDisplayStatus.Billed },
            { label: 'Canceled', value: PendingAreaDisplayStatus.Canceled }];
    }

    static getTitleById(id): string {
        return this.getLookup().find(f => f.value === id)?.label || '';
    }

    static getById(id): SelectItem {
        return this.getLookup().find(f => f.value === id) || null;
    }

    static getDisplayTitleById(id): string {
        return this.getAll().find(f => f.value === id)?.label || '';
    }
}
